import axios from 'axios'

// Create axios instance
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_DATABASE_HOST,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

// Strapi 3 caps collection responses at 100 records when no _limit is sent
// (api.rest.defaultLimit) and applies no ordering, so it is undefined which
// records come back. The store holds whole collections and resolves entities
// from there, which made records vanish from the UI without any error once a
// collection grew past 100. Request all records unless a caller paginates
// deliberately.
export const withCollectionLimit = config => {
  if ((config.method || 'get').toLowerCase() !== 'get') return config

  const params = config.params || {}
  if (Object.prototype.hasOwnProperty.call(params, '_limit')) return config

  return { ...config, params: { ...params, _limit: -1 } }
}

// Request interceptor to add JWT token
apiClient.interceptors.request.use(
  config => {
    const limited = withCollectionLimit(config)
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user && user.jwt) {
      return {
        ...limited,
        headers: {
          ...limited.headers,
          Authorization: `Bearer ${user.jwt}`
        }
      }
    }
    return limited
  },
  error => Promise.reject(error)
)

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Token expired or invalid - redirect to login
      localStorage.removeItem('user')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default () => apiClient
